import React, {useEffect} from 'react';
import "./Contact.scss";

declare global {
    interface Window {
        hbspt: any;
    }
}

function Contact() {
    useEffect(() => {
        (function loadHubSpot() {
            window.hbspt.forms.create({ 
                region: "na1",
                portalId: "5152848",
                formId: "6e535727-ffeb-41dd-aa32-d10483a323be",
                target: '.contact-wrapper'
            });
        })();
    }, []);

    return (
        <><div className="contacts-block">
            <p className={'contact-us-form'}>Contact us:</p>
            <div className="contact-wrapper animate__animated animate__zoomInDown"></div>
            </div>
        </>
    );
}

export default Contact;
